import { track } from './analytics';

let installed = false;

/**
 * Capture uncaught errors + unhandled promise rejections and forward them to the analytics layer
 * as `client_error` events. Dependency-free operational monitoring; swap the `track` calls for
 * `Sentry.captureException` once a Sentry DSN is wired (see ADR-0007).
 */
export function initErrorMonitoring() {
  if (installed || typeof window === 'undefined') {
    return;
  }
  installed = true;

  window.addEventListener('error', (e) => {
    track('client_error', {
      message: e.message,
      source: e.filename,
      line: e.lineno,
      col: e.colno,
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    track('client_unhandled_rejection', {
      message: (reason && reason.message) || String(reason),
    });
  });
}
